import React, { ComponentProps } from 'react';
import { IconButton } from 'react-native-paper';
import PointIcon from '../CustomIcon';
import { getActions, getItemListClick, isCheckColor } from '../../shared';
import { processStyles } from '../util.style';
import ActionButtonConfig from './config';

type Props = ComponentProps<typeof IconButton> | any;

// Helper function to safely convert color values to strings
const colorToString = (color: any, fallback: string = '#ffffff'): string => {
  if (typeof color === 'string') return color;
  if (color === null || color === undefined) return fallback;
  return String(color);
};

const ActionButton: React.FC<Props> = (props) => {
  const {
    attributes,
    onPress,
    style,
    libraryComponentManifest,
    ...otherProps
  } = props;

  // Process styles with simple utility
  const { finalStyle, componentProps } = processStyles({
    attributes,
    style,
    config: ActionButtonConfig,
    libraryComponentManifest,
    ...otherProps,
  });

  // Extract component-specific props (non-style attributes)
  const { nameIcon } = componentProps;

  const handlePress = () => {
    onPress(getActions(props, 'action'), {
      itemListClick: getItemListClick(props.record),
    });
  };

  const containerStyle = {
    opacity: finalStyle.opacity || 1,
    borderRadius: finalStyle.borderRadius || 28,
    backgroundColor: isCheckColor(
      colorToString(finalStyle.backgroundColor, '#4259AC')
    )
      ? colorToString(finalStyle.backgroundColor, '#4259AC')
      : '#4259AC',
    margin: finalStyle.margin || 0,
    marginTop: finalStyle.marginTop,
    marginRight: finalStyle.marginRight,
    marginBottom: finalStyle.marginBottom,
    marginLeft: finalStyle.marginLeft,
    width: finalStyle.width || props.width || 56,
    height: finalStyle.height || props.height || 56,
    zIndex: finalStyle.zIndex || 1,
    elevation: finalStyle.elevation || 0,
    shadowColor: finalStyle.shadowColor,
    shadowOffset: finalStyle.shadowOffset,
    shadowOpacity: finalStyle.shadowOpacity,
    shadowRadius: finalStyle.shadowRadius,
  };

  const iconColor = colorToString(finalStyle.color, '#ffffff');

  const iconSize = finalStyle.fontSize || 24;

  const childProps: Props = {
    icon:
      nameIcon === 'point'
        ? () => <PointIcon width={24} height={24} fill={iconColor} />
        : nameIcon,
    style: containerStyle,
    color: iconColor,
    size: iconSize,
    ...componentProps,
  };

  return <IconButton onPress={handlePress} {...childProps} />;
};

export default ActionButton;
